export const drawerPaperSx = {
  top: { xs: "96px", sm: "104px", md: "125px" },
  height: {
    xs: "calc(100vh - 96px)",
    sm: "calc(100vh - 104px)",
    md: "calc(100vh - 125px)",
  },
  maxWidth: "100%",
  width: { xs: "min(100%, 560px)", sm: 740 },
  boxSizing: "border-box",
  borderLeft: "1px solid rgba(0, 0, 0, 0.08)",
  boxShadow: "-4px 0 24px rgba(0, 0, 0, 0.08)",
  borderRadius: 0,
  backgroundColor: "#fff",
};

export const drawerRootBoxSx = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflow: "hidden",
};

export const drawerTitleSx = {
  fontWeight: 700,
  fontSize: "1.125rem",
  color: "#000",
  px: 2,
  pt: 2,
  pb: 2,
  flexShrink: 0,
};

export const drawerSplitLayoutSx = {
  display: "flex",
  flex: 1,
  minHeight: 0,
  borderTop: "1px solid #e0e0e0",
};

export const drawerTabsPaneSx = {
  width: 190,
  borderRight: "1px solid #e0e0e0",
  backgroundColor: "#f8f9fb",
  flexShrink: 0,
  py: 1,
};

export const drawerTabsSx = {
  minHeight: "auto",
  alignItems: "stretch",
  "& .MuiTabs-indicator": {
    left: 0,
    width: 3,
    borderRadius: 0,
  },
};

export const drawerTabSx = {
  alignItems: "flex-start",
  justifyContent: "flex-start",
  textAlign: "left",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "16px",
  color: "#344767",
  px: 2,
  py: 1.25,
  minHeight: 44,
};

export const drawerTabPanelSx = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0,
  minHeight: 0,
};

export const dataConnectionsFormSx = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  gap: 2,
  p: 2,
};

export const dataConnectionsFieldSx = {
  flex: 1,
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
  },
};

export const dataConnectionsFieldRadius = "4px";

const dataConnectionsFieldRadiusForced = `${dataConnectionsFieldRadius} !important`;

export const dataConnectionsHachwimsAutocompleteSx = {
  flex: 1,
  minWidth: 0,
  width: "100%",
  borderRadius: dataConnectionsFieldRadiusForced,
  "& .MuiFormControl-root": {
    borderRadius: dataConnectionsFieldRadiusForced,
  },
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
    borderRadius: dataConnectionsFieldRadiusForced,
  },
  "& .MuiOutlinedInput-root": {
    flexWrap: "wrap",
    alignItems: "flex-start",
    py: 0.75,
    borderRadius: dataConnectionsFieldRadiusForced,
  },
  "& .MuiAutocomplete-inputRoot": {
    borderRadius: dataConnectionsFieldRadiusForced,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: dataConnectionsFieldRadiusForced,
  },
  "& .MuiAutocomplete-input": {
    minWidth: "48px !important",
  },
};

export const dataConnectionsHachwimsTagsScrollSx = {
  display: "grid",
  gridAutoFlow: "column",
  gridTemplateRows: "repeat(2, auto)",
  gridAutoColumns: "max-content",
  gap: 0.5,
  width: "100%",
  maxHeight: 88,
  overflowX: "auto",
  overflowY: "hidden",
  alignItems: "start",
  alignContent: "start",
  "& .MuiChip-root": {
    maxWidth: 200,
    "& .MuiChip-label": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
};

export const dataConnectionsFieldRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  minWidth: 0,
};

export const dataConnectionsFieldLabelSx = {
  width: 110,
  flexShrink: 0,
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "#344767",
};

export const dataConnectionsHachwimsFieldRowSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: 2,
  minWidth: 0,
};

export const dataConnectionsHachwimsFieldLabelSx = {
  ...dataConnectionsFieldLabelSx,
  pt: 0.75,
};

export const dataConnectionsActionsRowSx = {
  display: "flex",
  justifyContent: "flex-end",
  pt: 1,
  mt: "auto",
};

export const columnHeaderRowSx = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "8px 16px",
  borderBottom: "1px solid #e0e0e0",
  flexShrink: 0,
};

export const columnHeaderLabelSx = {
  fontWeight: 600,
  fontSize: "0.875rem",
  color: "#344767",
};

export const columnHeaderAccessCellSx = {
  display: "flex",
  alignItems: "center",
  gap: 0.25,
};

export const accessInfoIconButtonSx = {
  p: 0.25,
  color: "#5c6c7c",
  "&:hover": {
    color: "#344767",
    backgroundColor: "transparent",
  },
};

export const accessInfoOutlinedIconSx = {
  fontSize: 16,
};

export const accessColumnTooltipSlotProps = {
  tooltip: {
    sx: {
      bgcolor: "#37474f",
      color: "#fff",
      fontSize: "0.8125rem",
      fontWeight: 400,
      lineHeight: 1.4,
      maxWidth: 280,
      px: 1,
      py: 0.75,
      "& .MuiTooltip-arrow": {
        color: "#37474f",
      },
    },
  },
};

export const scrollAreaSx = {
  flex: 1,
  overflowY: "auto",
  px: 0,
};

export const drawerLoadingBoxSx = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  py: 4,
};

const moduleRowSxBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  px: 2,
  py: "6px",
};

export const getModuleRowSx = (index, totalRows) => ({
  ...moduleRowSxBase,
  borderBottom: index < totalRows - 1 ? "1px solid #eeeeee" : "none",
});

export const moduleLabelTypographySx = {
  fontSize: "0.9375rem",
  color: "#344767",
  flex: 1,
  pr: 1,
};
